module.exports = __webpack_public_path__ + "static/media/sas.2809a6e7.png";